import { Container } from 'react-bootstrap';
import './Grievance.css';

function Grievance() {
  return (
    <section className="product-main">
      <Container className="grievance-container">
        <div className="grievance-card">
          <h2 className="grievance-title">Grievance Redressal Process</h2>
          
          <p className="grievance-intro" style={{marginBottom : "10px"}}>
            We believe in providing the best of our services to our investors, Distributor and Channel Partners. We provide easy access to information on our products and services; we also help you get your grievances redressed with ease. Resolving your problem helps us review our processes and take necessary steps to prevent recurrence. We aim to respond to your complaint with efficiency, courtesy and fairness.
          </p>

          <div className="escalation-step">
            <h3 className="step-title">Escalation Level 1</h3>
            <ul className="step-list">
              <li >Contact Call Centre on <strong>1800 1038 345</strong> - From Monday to Saturday between 9 am to 7 pm</li>
              <li>Email - In case of any grievance / complaint, an investor can send their complaint to <a href="mailto:investor@jmfl.com">investor@jmfl.com</a></li>
            </ul>
          </div>

          <div className="escalation-step">
            <h3 className="step-title">Escalation Level 2 – Customer Service Head</h3>
            <p className="step-desc">
              If the resolution you receive does not meet your expectations or not received any resolution, please write to our Head Investor Relation Officer @ <a href="mailto:jmirho@jmfinancial.in">jmirho@jmfinancial.in</a>
            </p>
          </div>

          <div className="escalation-step">
            <h3 className="step-title">Escalation Level 3 – Head of Operations</h3>
            <p className="step-desc">
              In case the concern still unresolved and you wish to escalate, please write to our HOD at <a href="mailto:pradyumna.khare@jmfl.com">pradyumna.khare@jmfl.com</a>
            </p>
          </div>

          <div className="escalation-step">
            <h3 className="step-title">Escalation Level 4 – SEBI Scores</h3>
            <p className="step-desc">
              If you are not satisfied with the resolution you receive from JM Financial Mutual Fund, you may approach SEBI at below mentioned link:<br />
              <a href="https://scores.sebi.gov.in/" target="_blank" rel="noopener noreferrer">https://scores.sebi.gov.in/</a>
            </p>
          </div>

          <div className="escalation-step">
            <h3 className="step-title">Escalation Level 5 – SMART ODR Portal</h3>
            <p className="step-desc">
              If you are not satisfied with the resolution you receive from JM Financial Mutual Fund and SEBI Scores Platform, you may approach SEBI at below mentioned links:<br />
              <a href="https://smartodr.in/login" target="_blank" rel="noopener noreferrer">https://smartodr.in/login</a>
            </p>
          </div>
        </div>
      </Container>
    </section>
  );
}

export default Grievance;